import { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { db } from "../firebase.ts";
import React from "react";

type GalleryDoc = {
  title?: string;
  alt?: string;
  published?: boolean;
  createdAt?: any;
  image?: { downloadURL?: string }[];
};

export default function GalleryPage() {
  const [images, setImages] = useState<Array<{ id: string; data: GalleryDoc }>>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError("");

        const q = query(
          collection(db, "Gallery"),
          where("published", "==", true),
          orderBy("createdAt", "desc")
        );

        const snap = await getDocs(q);

        setImages(
          snap.docs.map((d) => ({
            id: d.id,
            data: d.data() as GalleryDoc,
          }))
        );
      } catch (e: any) {
        setError(e?.message || "Failed to load gallery");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen px-6 py-16 bg-white">
      <h1 className="text-4xl font-bold text-center mb-10 text-red-600">
        Memories from Broadway Bingo!
      </h1>

      {loading && <p className="text-center text-gray-600">Loading…</p>}
      {error && <p className="text-center text-red-600">{error}</p>}

      {!loading && !error && images.length === 0 && (
        <p className="text-center text-gray-500">Photos coming soon!</p>
      )}

      {!loading && !error && images.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {images.map(({ id, data }) => (
            <div
              key={id}
              className="rounded-2xl overflow-hidden shadow-lg bg-white"
            >
              <img
                src={data.image?.[0]?.downloadURL || ""}
                alt={data.alt || data.title || "Gallery photo"}
                className="w-full h-72 object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}